import React, { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
// FUTURE: rangeslider repo is no longer active. Replace.
import Slider from 'react-rangeslider';

import CateringUtils from '../../../modules/cateringUtils';
import ButtonSet from '../../shared/ButtonSet';

import 'react-rangeslider/lib/index.css';
import styles from './CostEstimator.module.postcss';

const MEALS = ['Entree', 'Side', 'Drink', 'Dessert'];
const SLIDER_LABELS = { 50: '50', 250: '250' };

function MealButton({ id, meals, onSelectMeal }) {
  return (
    <label
      key={id}
      htmlFor={id}
      className={cn(styles.CostEstimator_checkbox, {
        [styles.CostEstimator_checkbox__checked]: meals.includes(id),
      })}
    >
      <span>{id}</span>
      <input
        id={id}
        name='meal'
        onChange={onSelectMeal}
        type='checkbox'
        value={id}
      />
    </label>
  );
}

function CostEstimator({ title }) {
  const [meals, setMeals] = useState(['Side']);
  const [people, setPeople] = useState(60);

  const onSelectMeal = (e) => {
    const meal = e.target.value;
    setMeals((prevMeals) => {
      return prevMeals.includes(meal)
        ? prevMeals.filter((m) => m !== meal)
        : [...prevMeals, meal];
    });
  };

  const onChangeSlider = (value) => {
    setPeople(value);
  };

  const getEstimate = () => {
    const { low, high } = CateringUtils.calculateBudgetRange({
      food_options: meals,
      number_of_trucks: 1,
      number_of_people: people,
    });

    return `$${low} - $${high}`;
  };

  return (
    <section className={styles.CostEstimator + ' Section'}>
      <h3 className='u-phosphate'>{title || 'Catering cost estimator'}</h3>
      <div className={styles.CostEstimator_contents}>
        <div>
          <p className='u-mb2'>About how many people are you expecting?</p>
          <Slider
            labels={SLIDER_LABELS}
            max={250}
            min={50}
            onChange={onChangeSlider}
            step={10}
            value={people}
          />
        </div>
        <div>
          <p>What are you serving?</p>
          <ButtonSet className={styles.CostEstimator_buttonSet}>
            { MEALS.map((id) => {
              return <MealButton key={id} id={id} meals={meals} onSelectMeal={onSelectMeal} />;
            }) }
          </ButtonSet>
        </div>
        <div>
          <p>Cost estimate</p>
          <p className={styles.CostEstimate_estimate}>{getEstimate()}</p>
        </div>
      </div>
      <Link to='/catering/register' className='Button u-mt2'>
        Get started with a quote!
      </Link>
    </section>
  );
}

export default CostEstimator;
